export enum Looping {
    NONE,
    LOOP,
    PINGPONG
}

export enum PlayDirection {
    FORWARD,
    BACKWARD
}